var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerCharge4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2345_64977)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.375 24.75C8.375 11.0786 19.6351 0 33.5273 0C47.4196 0 58.6797 11.0786 58.6797 24.75C58.6797 38.4147 33.5273 66 33.5273 66C33.5273 66 8.375 38.4147 8.375 24.75ZM16.7568 24.75C16.7568 33.862 24.2704 41.25 33.5273 41.25C42.7911 41.25 50.2979 33.862 50.2979 24.75C50.2979 15.638 42.7911 8.25 33.5273 8.25C24.2636 8.25 16.7568 15.638 16.7568 24.75ZM29.4173 27.4676L44.5092 15.1994L47.3215 18.1555L31.3203 35.2601L29.7551 36.935L28.2546 35.2046L19.7332 25.3989L22.5118 22.4344L29.4173 27.4676Z",
    fill: "#6ABF62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2345_64977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCharge4);
export default __webpack_public_path__ + "static/media/marker-charge4.1fd94e9dfe2806f7eebfad9e2b9057e6.svg";
export { ForwardRef as ReactComponent };